// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Inter-VariableFont_slnt,wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'Inter';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
		format('truetype');
}

:root {
	--stroke-soft: #f2f2f5;
	--base-higher-p: #fff;
	--base-white: #fff;
	--border-red: #ff3b3b;
	--border-orange: #ff8800;
	--border-blue: #3e7bfa;
	--gradient-red: linear-gradient(90deg, #ff3b3b, #cc00bb);
	--gradient-orange: linear-gradient(90deg, #ff8800, #ee5d5d);
	--gradient-blue: linear-gradient(90deg, #3e7bfa, #6600cc);
}
* {
	box-sizing: border-box;
}

input:focus-visible,
textarea:focus-visible,
select:focus-visible {
	outline: 1px solid #ebebf0;
	box-shadow: 0px 0.5px 4px 0px rgba(96, 97, 112, 0.32) inset;
	border-radius: 0.25rem;
}

html {
	font-family: 'Inter', sans-serif;
	font-size: 16px;
	background: #fafafc;
	overflow: hidden;
}

header {
	display: flex;
	justify-content: center;
	z-index: 1;

	position: fixed;
	top: 0;

	margin-top: 3vh;
	width: 100%;
	gap: 1.7rem;

	animation: slideTopMiddle 1.5s;
}

p {
	margin: 0;
}

.container {
	position: relative;
	margin-top: 10vh;
	height: 90vh;
}

/* Add TODO BTN */
.cancelForm:hover,
.deleteTodo:hover,
.deleteTodoEdit:hover,
.cancelListForm:hover,
.deleteList:hover {
	background: #ff3b3b;
}

.cancelForm,
.deleteTodo,
.deleteTodoEdit,
.deleteList {
	width: 0.8rem;
	height: 0.8rem;

	background-color: var(--base-higher-p, #fff);
	border: 1px solid #dadadd;
	border-radius: 100%;
	filter: drop-shadow(0px 20px 32px rgba(96, 97, 112, 0.24))
		drop-shadow(0px 2px 8px rgba(40, 41, 61, 0.08));

	font-size: 0.6rem;
	text-align: center;
	color: transparent;
}

.addTodoBtn {
	display: flex;
	justify-content: center;
	align-items: center;

	height: 2.75rem;
	width: 2.75rem;
	padding-bottom: 0.4rem;

	border: 1px solid var(--stroke-soft, #f2f2f5);
	border-radius: 3.125rem;
	background: var(--base-white, #fff);

	box-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),
		0px 0px 2px 0px rgba(40, 41, 61, 0.04);

	font-family: Inter, sans-serif;
	color: #1c1c28;
	font-feature-settings: 'clig' off, 'liga' off;
	font-size: 2.25rem;
	font-style: normal;
	font-weight: 200;
	line-height: 1.5rem;

	cursor: pointer;
}

.hamburger {
	display: flex;
	width: 5rem;
	height: 2.5rem;
	justify-content: center;
	align-items: center;

	border-radius: 0.75rem;
	border: 1px solid var(--stroke-soft, #f2f2f5);
	background: var(--base-white, #fff);
	box-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),
		0px 0px 2px 0px rgba(40, 41, 61, 0.04);

	font-family: Inter, sans-serif;
	color: #1c1c28;
	font-feature-settings: 'clig' off, 'liga' off;
	font-size: 1.1rem;
	font-style: normal;
	font-weight: 300;
	line-height: 1.5rem;

	cursor: pointer;
}

.addTodoBtn:hover,
.hamburger:hover {
	border: 2px solid #ebebf0;
}

.addTodoBtn:active,
.hamburger:active {
	border: 3px solid #e4e4eb;
}

.sidebar {
	z-index: 1;
	display: flex;
	flex-direction: column;
	gap: 30px;

	width: 10.5rem;

	transition: transform 0.5s;
	/* transform: translateX(-150%); */

	position: fixed;
	top: 23%;
	left: 14%;
}

.showSidebar {
	/* transform: translateX(-150%); */
	transform: translateY(400%);
}

.defaultSideLists,
.customSideLists {
	display: grid;
	grid-auto-rows: 2rem;
	grid-template-columns: 8rem;
	align-items: flex-start;

	width: 11rem;
	padding: 0.6rem 1.4rem;

	border-radius: 1.25rem;
	border: 1px solid var(--stroke-soft, #f2f2f5);
	background: var(--base-white, #fff);

	box-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),
		0px 0px 2px 0px rgba(40, 41, 61, 0.04);
}

.defaultSideLists > .sidebarButton:last-child,
.customSideLists > .sidebarButton:last-child {
	border: 0;
}

.sidebarButton {
	width: 100%;
	height: 100%;

	border: 0;
	border-bottom: 1px solid #ebebf0;
	background: transparent;

	text-align: left;

	font-family: Inter, sans-serif;
	color: #1c1c28;
	font-size: 0.9rem;
	font-style: normal;
	font-weight: 300;
	line-height: 1.5rem;
	text-overflow: ellipsis;

	cursor: pointer;
}

.activeSideButton {
	color: #3568d4;
	font-weight: 700;
}

/** LIST */

.list {
	display: flex;
	flex-direction: column;
	align-items: center;

	height: 100%;
	width: clamp(25rem, 40rem, 55rem);
	margin: auto;

	/* overflow: hidden; */
}

.listHead {
	align-self: baseline;

	display: grid;
	grid-template-rows: 3rem 0.5rem 3rem;
	grid-template-columns: 2.4rem auto 2.4rem;

	width: 100%;
	height: 6.875rem;
}

.deleteList {
	grid-row: 2;
	justify-self: flex-start;
}

.listTitle,
.customTitle {
	grid-row: 1;
	align-self: end;
	grid-column: 2;

	font-family: Inter, sans-serif;
	color: var(--dark-dark-0, #1c1c28);
	font-size: 2rem;
	font-style: normal;
	font-weight: 300;
	line-height: normal;
	letter-spacing: 0.1rem;

	text-overflow: ellipsis;
}

.listDescription,
.customDescription {
	grid-row: 3;
	grid-column: 2;

	font-family: Inter, sans-serif;
	color: rgba(28, 28, 40, 0.22);
	font-feature-settings: 'clig' off, 'liga' off;
	font-size: 0.9rem;
	font-style: normal;
	font-weight: 300;
	line-height: 1.5rem;

	text-overflow: ellipsis;
}

.customDescription::placeholder {
	color: rgba(28, 28, 40, 0.18);
	font-size: 0.9rem;
	font-style: normal;
	font-weight: 300;
}

.customTitle,
.customDescription {
	background: transparent;
	border: 0;
}

.completedTodosTitle {
	display: flex;
	align-items: center;

	width: 85%;
	height: 2rem;
	border-bottom: 1px solid rgba(185, 185, 185, 0.1);
	margin-top: 0.3rem;

	font-size: 0.8rem;
	font-family: Inter, sans-serif;
	color: rgba(28, 28, 40, 0.2);
	font-weight: 300;
	letter-spacing: 0.5px;

	animation: fadeIn ease-in 1.5s;
}

.activeTodos,
.completedTodos {
	/*  MASK OVERFLOW fade */
	--mask-image-content: linear-gradient(
		to bottom,
		transparent,
		black 2rem,
		black calc(100% - 2rem),
		transparent
	);

	mask-image: var(--mask-image-content);
	mask-repeat: no-repeat;
	/* Hide scrollbar */
	-ms-overflow-style: none;
	scrollbar-width: none;

	display: flex;
	flex-direction: column;
	align-items: center;

	width: 100%;

	padding-top: 0.5rem;

	overflow-y: auto;
}

.emptySubList {
	z-index: 1;
	padding-top: 2rem;
	font-size: 1rem;
	color: #e4e4eb;
}

.activeTodos::-webkit-scrollbar,
.completedTodos::-webkit-scrollbar {
	display: none;
}

.activeTodos {
	height: 50%;
}

.completedTodos {
	height: 25%;
}

.emptyCompletedButton {
	z-index: 1;

	position: fixed;
	bottom: 1rem;

	display: flex;

	height: 2rem;
	padding: 0.25rem 0.5rem;

	justify-content: center;
	align-items: center;
	border-radius: 0.75rem;
	border: 1px solid var(--stroke-soft, #f2f2f5);
	background: var(--base-white, #fff);
	box-shadow: 0px 0.5px 2px 0px rgba(96, 97, 112, 0.16),
		0px 0px 1px 0px rgba(40, 41, 61, 0.08);
	font-family: Inter, sans-serif;
	color: #c7c9d9;
	font-feature-settings: 'clig' off, 'liga' off;
	font-size: 0.7rem;
	font-style: normal;
	font-weight: 300;
	line-height: 1.5rem;

	cursor: pointer;
}

.slide-top-middle {
	animation: slideTopMiddle 450ms;
}

.slide-middle-top {
	animation: slideMiddleTop 450ms;
}

.slide-middle-bottom {
	animation: slideMiddleBottom 450ms;
}

.slide-bottom-middle {
	animation: slideBottomMiddle 450ms;
}

@keyframes slideTopMiddle {
	from {
		transform: translateY(-200%);
	}
	to {
		transform: translateY(0);
	}
}

@keyframes slideMiddleTop {
	from {
		transform: translateY(0);
	}
	to {
		transform: translateY(-200%);
	}
}

@keyframes slideMiddleBottom {
	from {
		transform: translateY(0);
	}
	to {
		transform: translateY(200%);
	}
}

@keyframes slideBottomMiddle {
	from {
		transform: translateY(200%);
	}

	to {
		transform: translateY(0);
	}
}

.fadeIn {
	animation: fadeIn ease-in 1s;
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

/* TODO */

/* TODO FORM */

#todoForm {
	z-index: 3;
	position: absolute;
	top: 25%;
	left: 50%;
	transform: translate(-50%, -50%);

	display: grid;
	grid-template-rows: repeat(4, 4rem);
	grid-template-columns: 1fr 1fr 1fr;

	width: clamp(25rem, 40rem, 55rem);
	height: 18rem;
	margin: auto;
	padding: 15px 25px;

	border-radius: 20px;
	background: #e3e3e31c;
	backdrop-filter: blur(20px);
	-webkit-backdrop-filter: blur(20px);

	font-family: Inter, sans-serif;
	color: #1c1c28;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5rem;

	text-overflow: ellipsis;
}

.darkBgd {
	position: absolute;
	top: -0.3%;
	left: -0.3%;
	box-shadow: 0px 0 300px 999px #84848454;
	border-radius: 23px;
	height: 102%;
	width: 100.7%;
	pointer-events: none;
}

.showForm {
	animation-name: showForm;
	animation-duration: 900ms;
}

@keyframes showForm {
	from {
		top: -200%;
	}

	to {
		top: 25%;
	}
}

.removeForm {
	animation-name: removeForm;
	animation-duration: 1s;
}

@keyframes removeForm {
	from {
		top: 25%;
	}

	25% {
		top: -200%;
	}

	to {
		top: -200%;
	}
}

.cancelForm {
	position: absolute;
	top: 10px;
	right: 10px;
	background: #bebebe1c;
}

#formTitle,
#formNotes,
#formDate,
#formList,
#formPriority {
	height: 100%;
	width: 100%;
	padding: 0.25rem;

	border: 0;
	background: transparent;
}

.formTitle {
	grid-area: 1 / 1 / 1 / 4;
	align-self: center;
}

#formTitle {
	width: 100%;
	padding: 0.25rem;
	font-size: 1.5rem;
	border-bottom: 1px solid #b5b4b43f;
}

.formNotes {
	grid-area: 2 / 1 / 4 / 4;
	align-self: center;

	height: 100%;
	width: 100%;
	margin-bottom: 0.25rem;

	border-radius: 0.25rem;
	border: 1px solid #a1a2a430;
}

#formNotes {
	padding: 10px;
}

textarea {
	resize: none;
	overflow: scroll;
}

.formDate,
.formList,
.formPriority {
	align-self: end;
	padding: 10px 0px;
}

.formList {
	grid-area: 4 / 1;
	justify-self: baseline;
	width: 100%;
}

#formList {
	padding-left: 10px;
	font-size: 1.1rem;
	font-weight: 300;
}

.formDate {
	grid-area: 4 / 2;

	display: flex;
	justify-self: center;
	justify-content: center;
}

#formDate {
	display: flex;
	align-content: center;

	width: 70%;

	text-align: center;
	font-size: 1rem;
	font-weight: 300;
}

.formPriority {
	grid-area: 4 / 3;
	padding-right: 10px;

	font-size: 1.1rem;
	font-weight: 300;
}

#formPriority {
	text-align: right;
}

#formList,
#formPriority {
	-moz-appearance: none;
	-webkit-appearance: none;
}

.submitButton {
	z-index: 3;
	position: absolute;
	bottom: -3rem;

	height: 2rem;
	width: 6.5rem;

	align-self: end;
	justify-self: center;

	background: #e3e3e3;
	backdrop-filter: blur(20px);
	-webkit-backdrop-filter: blur(20px);
	border: 1px solid #e4e4eb;
	border-radius: 3.125rem;
	box-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),
		0px 0px 2px 0px rgba(40, 41, 61, 0.04);

	font-family: Inter, sans-serif;
	color: #1c1c28;
	font-feature-settings: 'clig' off, 'liga' off;
	font-size: 1.1rem;
	font-style: normal;
	font-weight: 300;

	cursor: pointer;
}

/* TODO CARD */

.todoCard {
	position: relative;

	display: grid;
	grid-template-columns: 1rem auto 4rem 1rem;
	grid-template-rows: 1.5rem;
	gap: 0.25rem;
	row-gap: 0.5rem;
	overflow: clip;

	width: clamp(20rem, 35rem, 35rem);
	min-height: 2.6875rem;
	height: 2.6875rem;

	margin: 0.5rem;
	padding: 0.5rem;

	border-radius: 0.9375rem;

	cursor: pointer;
}

.todoCardExtra {
	grid-template-rows: 1.5rem auto;

	transition: min-height 1s;
}

.todoCardExtra:hover {
	min-height: 10rem;
}

/* Create custom checkbox */
.todoCheck {
	grid-area: 1 / 1;
	align-self: center;
}

.todoTitle {
	grid-area: 1 / 2 / 1 / 4;
	height: 100%;

	/* overflow: hidden; */
	text-overflow: ellipsis;

	font-family: Inter, sans-serif;
	color: #1c1c28;
	font-size: 1.1rem;
	font-style: normal;
	font-weight: 300;
	line-height: 1;

	padding: 0.25rem;
	margin: 0;
	height: 100%;
}

.todoNotes {
	grid-area: 2 / 2 / 2 / 4;
	padding: 4px;
	margin: 0;
	border-radius: 0.25rem;
	border: 1px solid #a1a2a430;

	font-family: Inter, sans-serif;
	font-size: 0.75rem;
	font-weight: 300;
	overflow: scroll;
}

.todoDate {
	grid-area: 1 / 3;
	align-self: center;

	color: rgba(0, 0, 0, 0.4);
	font-size: 0.625rem;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.deleteTodo {
	grid-area: 1 / 4;
	align-self: center;
}

/* TODO CARD - edit */

.editCard {
	z-index: 3;
	position: relative;

	display: grid;
	grid-template-rows: 1.5rem auto 1.5rem;
	grid-template-columns: 1rem repeat(3, 1fr) 1rem;
	gap: 0.25rem;
	row-gap: 0.5rem;

	width: clamp(20rem, 35rem, 35rem);
	min-height: 10rem;

	padding: 0.5rem;
	margin: 0.5rem 0.5rem 0rem;
	border-radius: 1rem;

	font-family: Inter, sans-serif;
	color: #1c1c28;
	font-style: normal;
	font-weight: 400;
	text-overflow: ellipsis;
}

.todoTitleEdit,
.todoDueDateEdit,
.todoNotesEdit,
.todoPriorityEdit {
	background: transparent;
	border: 0;
	text-overflow: ellipsis;
}

.deleteTodoEdit {
	grid-row: 1;
	grid-column: 5;

	align-self: center;
}

.todoCheckEdit {
	grid-area: 1 / 1 / 1 / 1;

	align-self: center;
}

.todoTitleEdit {
	grid-area: 1 / 2 / 1 / 5;

	height: 100%;
	padding: 0.25rem;

	font-size: 1.1rem;
	font-weight: 300;
}

.todoNotesEdit {
	align-self: center;

	grid-column: 2 / span 3;
	grid-row: 2;

	height: 100%;
	padding: 0.25rem;
	border-radius: 0.25rem;
	border: 1px solid #a1a2a430;

	font-size: 0.75rem;
	font-weight: 300;
}

.todoListEdit {
	align-self: center;
	justify-self: start;

	grid-column: 2;
	grid-row: 3;

	width: 90%;
	padding: 0;
	border: 0;
	background: transparent;

	font-size: 0.9rem;
	font-weight: 300;

	-moz-appearance: none;
	-webkit-appearance: none;
}

.todoDueDateEdit {
	justify-self: center;
	align-self: center;

	grid-column: 3;
	grid-row: 3;

	width: 90%;
	padding: 0;

	text-align: center;
	font-size: 0.9rem;
	font-weight: 300;
}

.todoPriorityEdit {
	align-self: center;
	justify-self: end;

	grid-column: 4;
	grid-row: 3;

	width: 90%;
	padding: 0;

	font-size: 0.9rem;
	text-align: end;
	font-weight: 300;

	-moz-appearance: none;
	-webkit-appearance: none;
}

.done > * {
	color: #8080807d;
	text-decoration: line-through;
	color: rgba(128, 128, 128, 0.64);
}

/* Priority */
.low {
	background: linear-gradient(var(--base-white), var(--base-white)) padding-box,
		var(--gradient-blue) border-box;
	border: 1px solid;
	border-bottom: 2px solid;
	border-color: transparent;
	box-shadow: 0px 8px 16px 0px rgba(62, 123, 250, 0.35),
		0px 2px 4px 0px rgba(62, 123, 250, 0.37);
}

.medium {
	background: linear-gradient(var(--base-white), var(--base-white)) padding-box,
		var(--gradient-orange) border-box;
	border: 0.1rem solid;
	border-bottom: 2px solid;
	border-color: transparent;
	box-shadow: 0px 8px 16px 0px rgba(255, 136, 0, 0.23),
		0px 2px 4px 0px rgba(255, 136, 0, 0.4);
}

.high {
	background: linear-gradient(var(--base-white), var(--base-white)) padding-box,
		var(--gradient-red) border-box;
	border: 0.1rem solid;
	border-bottom: 2px solid;
	border-color: transparent;
	box-shadow: 0px 8px 16px 0px rgba(255, 59, 59, 0.35),
		0px 2px 4px 0px rgba(255, 59, 59, 0.69);
}

.none {
	background: var(--base-white, #fff);
	border: 1px solid #e4e4eb;

	box-shadow: 0px 8px 16px 0px rgba(96, 97, 112, 0.16),
		0px 2px 4px 0px rgba(40, 41, 61, 0.04);
}

/* displayChange */
.changeAlert {
	z-index: 80;

	position: fixed;
	bottom: -10%;
	left: 50%;

	display: flex;
	align-items: center;
	justify-content: center;

	transform: translateX(-50%) translateY(0%);
	transition: transform 0.6s;

	height: 3.4375rem;
	padding: 0 1rem;
	border-radius: 0.5rem;
	border: 1px solid var(--stroke-soft, #f2f2f5);
	background: var(--base-white, #fff);
	box-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),
		0px 0px 2px 0px rgba(40, 41, 61, 0.04);

	color: #1c1c28;

	font-family: Inter, sans-serif;
	font-size: 1.3rem;
	font-style: normal;
	font-weight: 700;
	line-height: 2rem; /* 133.333% */
	text-transform: uppercase;

	animation: showChangeAnimation 2.5s;
}

@keyframes showChangeAnimation {
	0% {
		bottom: -10rem;
	}
	25% {
		bottom: 0rem;
	}
	75% {
		bottom: 0rem;
	}
	100% {
		bottom: -10rem;
	}
}

footer {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB;oBACmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAwB;CACxB,sBAAsB;CACtB,wDAAwD;CACxD,2DAA2D;CAC3D,yDAAyD;AAC1D;AACA;CACC,sBAAsB;AACvB;;AAEA;;;CAGC,0BAA0B;CAC1B,2DAA2D;CAC3D,sBAAsB;AACvB;;AAEA;CACC,gCAAgC;CAChC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,UAAU;;CAEV,eAAe;CACf,MAAM;;CAEN,eAAe;CACf,WAAW;CACX,WAAW;;CAEX,8BAA8B;AAC/B;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;AACb;;AAEA,iBAAiB;AACjB;;;;;CAKC,mBAAmB;AACpB;;AAEA;;;;CAIC,aAAa;CACb,cAAc;;CAEd,4CAA4C;CAC5C,yBAAyB;CACzB,mBAAmB;CACnB;iDACgD;;CAEhD,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;;CAEnB,eAAe;CACf,cAAc;CACd,sBAAsB;;CAEtB,6CAA6C;CAC7C,uBAAuB;CACvB,mCAAmC;;CAEnC;wCACuC;;CAEvC,8BAA8B;CAC9B,cAAc;CACd,6CAA6C;CAC7C,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;;CAEnB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,cAAc;CACd,uBAAuB;CACvB,mBAAmB;;CAEnB,sBAAsB;CACtB,6CAA6C;CAC7C,mCAAmC;CACnC;wCACuC;;CAEvC,8BAA8B;CAC9B,cAAc;CACd,6CAA6C;CAC7C,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;;CAEnB,eAAe;AAChB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,UAAU;CACV,aAAa;CACb,sBAAsB;CACtB,SAAS;;CAET,cAAc;;CAEd,0BAA0B;CAC1B,kCAAkC;;CAElC,eAAe;CACf,QAAQ;CACR,SAAS;AACV;;AAEA;CACC,kCAAkC;CAClC,2BAA2B;AAC5B;;AAEA;;CAEC,aAAa;CACb,oBAAoB;CACpB,2BAA2B;CAC3B,uBAAuB;;CAEvB,YAAY;CACZ,sBAAsB;;CAEtB,sBAAsB;CACtB,6CAA6C;CAC7C,mCAAmC;;CAEnC;wCACuC;AACxC;;AAEA;;CAEC,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;;CAEZ,SAAS;CACT,gCAAgC;CAChC,uBAAuB;;CAEvB,gBAAgB;;CAEhB,8BAA8B;CAC9B,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;;CAEvB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA,UAAU;;AAEV;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;;CAEnB,YAAY;CACZ,iCAAiC;CACjC,YAAY;;CAEZ,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;;CAEpB,aAAa;CACb,oCAAoC;CACpC,yCAAyC;;CAEzC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,wBAAwB;AACzB;;AAEA;;CAEC,WAAW;CACX,eAAe;CACf,cAAc;;CAEd,8BAA8B;CAC9B,kCAAkC;CAClC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,sBAAsB;;CAEtB,uBAAuB;AACxB;;AAEA;;CAEC,WAAW;CACX,cAAc;;CAEd,8BAA8B;CAC9B,6BAA6B;CAC7B,6CAA6C;CAC7C,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;;CAEnB,uBAAuB;AACxB;;AAEA;CACC,6BAA6B;CAC7B,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;CAEC,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;;CAEnB,UAAU;CACV,YAAY;CACZ,iDAAiD;CACjD,kBAAkB;;CAElB,iBAAiB;CACjB,8BAA8B;CAC9B,4BAA4B;CAC5B,gBAAgB;CAChB,qBAAqB;;CAErB,8BAA8B;AAC/B;;AAEA;;CAEC,wBAAwB;CACxB;;;;;;EAMC;;CAED,qCAAqC;CACrC,sBAAsB;CACtB,mBAAmB;CACnB,wBAAwB;CACxB,qBAAqB;;CAErB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;;CAEnB,WAAW;;CAEX,mBAAmB;;CAEnB,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,iBAAiB;CACjB,eAAe;CACf,cAAc;AACf;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;;CAEV,eAAe;CACf,YAAY;;CAEZ,aAAa;;CAEb,YAAY;CACZ,uBAAuB;;CAEvB,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,6CAA6C;CAC7C,mCAAmC;CACnC;wCACuC;CACvC,8BAA8B;CAC9B,cAAc;CACd,6CAA6C;CAC7C,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;;CAEnB,eAAe;AAChB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC;EACC,4BAA4B;CAC7B;CACA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;CACA;EACC,4BAA4B;CAC7B;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;CACA;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,wBAAwB;CACzB;AACD;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;AACD;;AAEA,SAAS;;AAET,cAAc;;AAEd;CACC,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;;CAEhC,aAAa;CACb,mCAAmC;CACnC,kCAAkC;;CAElC,iCAAiC;CACjC,aAAa;CACb,YAAY;CACZ,kBAAkB;;CAElB,mBAAmB;CACnB,qBAAqB;CACrB,2BAA2B;CAC3B,mCAAmC;;CAEnC,8BAA8B;CAC9B,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;;CAEnB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,uCAAuC;CACvC,mBAAmB;CACnB,YAAY;CACZ,aAAa;CACb,oBAAoB;AACrB;;AAEA;CACC,wBAAwB;CACxB,yBAAyB;AAC1B;;AAEA;CACC;EACC,UAAU;CACX;;CAEA;EACC,QAAQ;CACT;AACD;;AAEA;CACC,0BAA0B;CAC1B,sBAAsB;AACvB;;AAEA;CACC;EACC,QAAQ;CACT;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;AACD;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,qBAAqB;AACtB;;AAEA;;;;;CAKC,YAAY;CACZ,WAAW;CACX,gBAAgB;;CAEhB,SAAS;CACT,uBAAuB;AACxB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,kCAAkC;AACnC;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;;CAElB,YAAY;CACZ,WAAW;CACX,sBAAsB;;CAEtB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;;;CAGC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;;CAEhB,aAAa;CACb,oBAAoB;CACpB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,qBAAqB;;CAErB,UAAU;;CAEV,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;;CAEnB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;CAEC,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,aAAa;;CAEb,YAAY;CACZ,aAAa;;CAEb,eAAe;CACf,oBAAoB;;CAEpB,mBAAmB;CACnB,2BAA2B;CAC3B,mCAAmC;CACnC,yBAAyB;CACzB,uBAAuB;CACvB;wCACuC;;CAEvC,8BAA8B;CAC9B,cAAc;CACd,6CAA6C;CAC7C,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;;CAEhB,eAAe;AAChB;;AAEA,cAAc;;AAEd;CACC,kBAAkB;;CAElB,aAAa;CACb,0CAA0C;CAC1C,0BAA0B;CAC1B,YAAY;CACZ,eAAe;CACf,cAAc;;CAEd,iCAAiC;CACjC,qBAAqB;CACrB,iBAAiB;;CAEjB,cAAc;CACd,eAAe;;CAEf,wBAAwB;;CAExB,eAAe;AAChB;;AAEA;CACC,+BAA+B;;CAE/B,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;AAClB;;AAEA,2BAA2B;AAC3B;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,YAAY;;CAEZ,sBAAsB;CACtB,uBAAuB;;CAEvB,8BAA8B;CAC9B,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;;CAEd,gBAAgB;CAChB,SAAS;CACT,YAAY;AACb;;AAEA;CACC,wBAAwB;CACxB,YAAY;CACZ,SAAS;CACT,sBAAsB;CACtB,2BAA2B;;CAE3B,8BAA8B;CAC9B,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;;CAElB,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA,qBAAqB;;AAErB;CACC,UAAU;CACV,kBAAkB;;CAElB,aAAa;CACb,sCAAsC;CACtC,+CAA+C;CAC/C,YAAY;CACZ,eAAe;;CAEf,iCAAiC;CACjC,iBAAiB;;CAEjB,eAAe;CACf,0BAA0B;CAC1B,mBAAmB;;CAEnB,8BAA8B;CAC9B,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;;;;CAIC,uBAAuB;CACvB,SAAS;CACT,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,cAAc;;CAEd,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;;CAExB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;;CAExB,YAAY;CACZ,gBAAgB;;CAEhB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;;CAElB,uBAAuB;CACvB,WAAW;;CAEX,YAAY;CACZ,gBAAgB;CAChB,sBAAsB;CACtB,2BAA2B;;CAE3B,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;;CAEnB,cAAc;CACd,WAAW;;CAEX,UAAU;CACV,UAAU;CACV,SAAS;CACT,uBAAuB;;CAEvB,iBAAiB;CACjB,gBAAgB;;CAEhB,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;;CAElB,cAAc;CACd,WAAW;;CAEX,UAAU;CACV,UAAU;;CAEV,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;;CAEjB,cAAc;CACd,WAAW;;CAEX,UAAU;CACV,UAAU;;CAEV,iBAAiB;CACjB,eAAe;CACf,gBAAgB;;CAEhB,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,gCAAgC;AACjC;;AAEA,aAAa;AACb;CACC;iCACgC;CAChC,iBAAiB;CACjB,wBAAwB;CACxB,yBAAyB;CACzB;0CACyC;AAC1C;;AAEA;CACC;mCACkC;CAClC,oBAAoB;CACpB,wBAAwB;CACxB,yBAAyB;CACzB;wCACuC;AACxC;;AAEA;CACC;gCAC+B;CAC/B,oBAAoB;CACpB,wBAAwB;CACxB,yBAAyB;CACzB;yCACwC;AACzC;;AAEA;CACC,mCAAmC;CACnC,yBAAyB;;CAEzB;wCACuC;AACxC;;AAEA,kBAAkB;AAClB;CACC,WAAW;;CAEX,eAAe;CACf,YAAY;CACZ,SAAS;;CAET,aAAa;CACb,mBAAmB;CACnB,uBAAuB;;CAEvB,0CAA0C;CAC1C,0BAA0B;;CAE1B,iBAAiB;CACjB,eAAe;CACf,qBAAqB;CACrB,6CAA6C;CAC7C,mCAAmC;CACnC;wCACuC;;CAEvC,cAAc;;CAEd,8BAA8B;CAC9B,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,yBAAyB;;CAEzB,mCAAmC;AACpC;;AAEA;CACC;EACC,cAAc;CACf;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,cAAc;CACf;AACD;;AAEA;CACC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB","sourcesContent":["@font-face {\n\tfont-family: 'Inter';\n\tsrc: url('./assets/fonts/Inter-VariableFont_slnt\\,wght.ttf')\n\t\tformat('truetype');\n}\n\n:root {\n\t--stroke-soft: #f2f2f5;\n\t--base-higher-p: #fff;\n\t--base-white: #fff;\n\t--border-red: #ff3b3b;\n\t--border-orange: #ff8800;\n\t--border-blue: #3e7bfa;\n\t--gradient-red: linear-gradient(90deg, #ff3b3b, #cc00bb);\n\t--gradient-orange: linear-gradient(90deg, #ff8800, #ee5d5d);\n\t--gradient-blue: linear-gradient(90deg, #3e7bfa, #6600cc);\n}\n* {\n\tbox-sizing: border-box;\n}\n\ninput:focus-visible,\ntextarea:focus-visible,\nselect:focus-visible {\n\toutline: 1px solid #ebebf0;\n\tbox-shadow: 0px 0.5px 4px 0px rgba(96, 97, 112, 0.32) inset;\n\tborder-radius: 0.25rem;\n}\n\nhtml {\n\tfont-family: 'Inter', sans-serif;\n\tfont-size: 16px;\n\tbackground: #fafafc;\n\toverflow: hidden;\n}\n\nheader {\n\tdisplay: flex;\n\tjustify-content: center;\n\tz-index: 1;\n\n\tposition: fixed;\n\ttop: 0;\n\n\tmargin-top: 3vh;\n\twidth: 100%;\n\tgap: 1.7rem;\n\n\tanimation: slideTopMiddle 1.5s;\n}\n\np {\n\tmargin: 0;\n}\n\n.container {\n\tposition: relative;\n\tmargin-top: 10vh;\n\theight: 90vh;\n}\n\n/* Add TODO BTN */\n.cancelForm:hover,\n.deleteTodo:hover,\n.deleteTodoEdit:hover,\n.cancelListForm:hover,\n.deleteList:hover {\n\tbackground: #ff3b3b;\n}\n\n.cancelForm,\n.deleteTodo,\n.deleteTodoEdit,\n.deleteList {\n\twidth: 0.8rem;\n\theight: 0.8rem;\n\n\tbackground-color: var(--base-higher-p, #fff);\n\tborder: 1px solid #dadadd;\n\tborder-radius: 100%;\n\tfilter: drop-shadow(0px 20px 32px rgba(96, 97, 112, 0.24))\n\t\tdrop-shadow(0px 2px 8px rgba(40, 41, 61, 0.08));\n\n\tfont-size: 0.6rem;\n\ttext-align: center;\n\tcolor: transparent;\n}\n\n.addTodoBtn {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\theight: 2.75rem;\n\twidth: 2.75rem;\n\tpadding-bottom: 0.4rem;\n\n\tborder: 1px solid var(--stroke-soft, #f2f2f5);\n\tborder-radius: 3.125rem;\n\tbackground: var(--base-white, #fff);\n\n\tbox-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),\n\t\t0px 0px 2px 0px rgba(40, 41, 61, 0.04);\n\n\tfont-family: Inter, sans-serif;\n\tcolor: #1c1c28;\n\tfont-feature-settings: 'clig' off, 'liga' off;\n\tfont-size: 2.25rem;\n\tfont-style: normal;\n\tfont-weight: 200;\n\tline-height: 1.5rem;\n\n\tcursor: pointer;\n}\n\n.hamburger {\n\tdisplay: flex;\n\twidth: 5rem;\n\theight: 2.5rem;\n\tjustify-content: center;\n\talign-items: center;\n\n\tborder-radius: 0.75rem;\n\tborder: 1px solid var(--stroke-soft, #f2f2f5);\n\tbackground: var(--base-white, #fff);\n\tbox-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),\n\t\t0px 0px 2px 0px rgba(40, 41, 61, 0.04);\n\n\tfont-family: Inter, sans-serif;\n\tcolor: #1c1c28;\n\tfont-feature-settings: 'clig' off, 'liga' off;\n\tfont-size: 1.1rem;\n\tfont-style: normal;\n\tfont-weight: 300;\n\tline-height: 1.5rem;\n\n\tcursor: pointer;\n}\n\n.addTodoBtn:hover,\n.hamburger:hover {\n\tborder: 2px solid #ebebf0;\n}\n\n.addTodoBtn:active,\n.hamburger:active {\n\tborder: 3px solid #e4e4eb;\n}\n\n.sidebar {\n\tz-index: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 30px;\n\n\twidth: 10.5rem;\n\n\ttransition: transform 0.5s;\n\t/* transform: translateX(-150%); */\n\n\tposition: fixed;\n\ttop: 23%;\n\tleft: 14%;\n}\n\n.showSidebar {\n\t/* transform: translateX(-150%); */\n\ttransform: translateY(400%);\n}\n\n.defaultSideLists,\n.customSideLists {\n\tdisplay: grid;\n\tgrid-auto-rows: 2rem;\n\tgrid-template-columns: 8rem;\n\talign-items: flex-start;\n\n\twidth: 11rem;\n\tpadding: 0.6rem 1.4rem;\n\n\tborder-radius: 1.25rem;\n\tborder: 1px solid var(--stroke-soft, #f2f2f5);\n\tbackground: var(--base-white, #fff);\n\n\tbox-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),\n\t\t0px 0px 2px 0px rgba(40, 41, 61, 0.04);\n}\n\n.defaultSideLists > .sidebarButton:last-child,\n.customSideLists > .sidebarButton:last-child {\n\tborder: 0;\n}\n\n.sidebarButton {\n\twidth: 100%;\n\theight: 100%;\n\n\tborder: 0;\n\tborder-bottom: 1px solid #ebebf0;\n\tbackground: transparent;\n\n\ttext-align: left;\n\n\tfont-family: Inter, sans-serif;\n\tcolor: #1c1c28;\n\tfont-size: 0.9rem;\n\tfont-style: normal;\n\tfont-weight: 300;\n\tline-height: 1.5rem;\n\ttext-overflow: ellipsis;\n\n\tcursor: pointer;\n}\n\n.activeSideButton {\n\tcolor: #3568d4;\n\tfont-weight: 700;\n}\n\n/** LIST */\n\n.list {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\theight: 100%;\n\twidth: clamp(25rem, 40rem, 55rem);\n\tmargin: auto;\n\n\t/* overflow: hidden; */\n}\n\n.listHead {\n\talign-self: baseline;\n\n\tdisplay: grid;\n\tgrid-template-rows: 3rem 0.5rem 3rem;\n\tgrid-template-columns: 2.4rem auto 2.4rem;\n\n\twidth: 100%;\n\theight: 6.875rem;\n}\n\n.deleteList {\n\tgrid-row: 2;\n\tjustify-self: flex-start;\n}\n\n.listTitle,\n.customTitle {\n\tgrid-row: 1;\n\talign-self: end;\n\tgrid-column: 2;\n\n\tfont-family: Inter, sans-serif;\n\tcolor: var(--dark-dark-0, #1c1c28);\n\tfont-size: 2rem;\n\tfont-style: normal;\n\tfont-weight: 300;\n\tline-height: normal;\n\tletter-spacing: 0.1rem;\n\n\ttext-overflow: ellipsis;\n}\n\n.listDescription,\n.customDescription {\n\tgrid-row: 3;\n\tgrid-column: 2;\n\n\tfont-family: Inter, sans-serif;\n\tcolor: rgba(28, 28, 40, 0.22);\n\tfont-feature-settings: 'clig' off, 'liga' off;\n\tfont-size: 0.9rem;\n\tfont-style: normal;\n\tfont-weight: 300;\n\tline-height: 1.5rem;\n\n\ttext-overflow: ellipsis;\n}\n\n.customDescription::placeholder {\n\tcolor: rgba(28, 28, 40, 0.18);\n\tfont-size: 0.9rem;\n\tfont-style: normal;\n\tfont-weight: 300;\n}\n\n.customTitle,\n.customDescription {\n\tbackground: transparent;\n\tborder: 0;\n}\n\n.completedTodosTitle {\n\tdisplay: flex;\n\talign-items: center;\n\n\twidth: 85%;\n\theight: 2rem;\n\tborder-bottom: 1px solid rgba(185, 185, 185, 0.1);\n\tmargin-top: 0.3rem;\n\n\tfont-size: 0.8rem;\n\tfont-family: Inter, sans-serif;\n\tcolor: rgba(28, 28, 40, 0.2);\n\tfont-weight: 300;\n\tletter-spacing: 0.5px;\n\n\tanimation: fadeIn ease-in 1.5s;\n}\n\n.activeTodos,\n.completedTodos {\n\t/*  MASK OVERFLOW fade */\n\t--mask-image-content: linear-gradient(\n\t\tto bottom,\n\t\ttransparent,\n\t\tblack 2rem,\n\t\tblack calc(100% - 2rem),\n\t\ttransparent\n\t);\n\n\tmask-image: var(--mask-image-content);\n\tmask-repeat: no-repeat;\n\t/* Hide scrollbar */\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\twidth: 100%;\n\n\tpadding-top: 0.5rem;\n\n\toverflow-y: auto;\n}\n\n.emptySubList {\n\tz-index: 1;\n\tpadding-top: 2rem;\n\tfont-size: 1rem;\n\tcolor: #e4e4eb;\n}\n\n.activeTodos::-webkit-scrollbar,\n.completedTodos::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.activeTodos {\n\theight: 50%;\n}\n\n.completedTodos {\n\theight: 25%;\n}\n\n.emptyCompletedButton {\n\tz-index: 1;\n\n\tposition: fixed;\n\tbottom: 1rem;\n\n\tdisplay: flex;\n\n\theight: 2rem;\n\tpadding: 0.25rem 0.5rem;\n\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 0.75rem;\n\tborder: 1px solid var(--stroke-soft, #f2f2f5);\n\tbackground: var(--base-white, #fff);\n\tbox-shadow: 0px 0.5px 2px 0px rgba(96, 97, 112, 0.16),\n\t\t0px 0px 1px 0px rgba(40, 41, 61, 0.08);\n\tfont-family: Inter, sans-serif;\n\tcolor: #c7c9d9;\n\tfont-feature-settings: 'clig' off, 'liga' off;\n\tfont-size: 0.7rem;\n\tfont-style: normal;\n\tfont-weight: 300;\n\tline-height: 1.5rem;\n\n\tcursor: pointer;\n}\n\n.slide-top-middle {\n\tanimation: slideTopMiddle 450ms;\n}\n\n.slide-middle-top {\n\tanimation: slideMiddleTop 450ms;\n}\n\n.slide-middle-bottom {\n\tanimation: slideMiddleBottom 450ms;\n}\n\n.slide-bottom-middle {\n\tanimation: slideBottomMiddle 450ms;\n}\n\n@keyframes slideTopMiddle {\n\tfrom {\n\t\ttransform: translateY(-200%);\n\t}\n\tto {\n\t\ttransform: translateY(0);\n\t}\n}\n\n@keyframes slideMiddleTop {\n\tfrom {\n\t\ttransform: translateY(0);\n\t}\n\tto {\n\t\ttransform: translateY(-200%);\n\t}\n}\n\n@keyframes slideMiddleBottom {\n\tfrom {\n\t\ttransform: translateY(0);\n\t}\n\tto {\n\t\ttransform: translateY(200%);\n\t}\n}\n\n@keyframes slideBottomMiddle {\n\tfrom {\n\t\ttransform: translateY(200%);\n\t}\n\n\tto {\n\t\ttransform: translateY(0);\n\t}\n}\n\n.fadeIn {\n\tanimation: fadeIn ease-in 1s;\n}\n\n@keyframes fadeIn {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n/* TODO */\n\n/* TODO FORM */\n\n#todoForm {\n\tz-index: 3;\n\tposition: absolute;\n\ttop: 25%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\n\tdisplay: grid;\n\tgrid-template-rows: repeat(4, 4rem);\n\tgrid-template-columns: 1fr 1fr 1fr;\n\n\twidth: clamp(25rem, 40rem, 55rem);\n\theight: 18rem;\n\tmargin: auto;\n\tpadding: 15px 25px;\n\n\tborder-radius: 20px;\n\tbackground: #e3e3e31c;\n\tbackdrop-filter: blur(20px);\n\t-webkit-backdrop-filter: blur(20px);\n\n\tfont-family: Inter, sans-serif;\n\tcolor: #1c1c28;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 1.5rem;\n\n\ttext-overflow: ellipsis;\n}\n\n.darkBgd {\n\tposition: absolute;\n\ttop: -0.3%;\n\tleft: -0.3%;\n\tbox-shadow: 0px 0 300px 999px #84848454;\n\tborder-radius: 23px;\n\theight: 102%;\n\twidth: 100.7%;\n\tpointer-events: none;\n}\n\n.showForm {\n\tanimation-name: showForm;\n\tanimation-duration: 900ms;\n}\n\n@keyframes showForm {\n\tfrom {\n\t\ttop: -200%;\n\t}\n\n\tto {\n\t\ttop: 25%;\n\t}\n}\n\n.removeForm {\n\tanimation-name: removeForm;\n\tanimation-duration: 1s;\n}\n\n@keyframes removeForm {\n\tfrom {\n\t\ttop: 25%;\n\t}\n\n\t25% {\n\t\ttop: -200%;\n\t}\n\n\tto {\n\t\ttop: -200%;\n\t}\n}\n\n.cancelForm {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n\tbackground: #bebebe1c;\n}\n\n#formTitle,\n#formNotes,\n#formDate,\n#formList,\n#formPriority {\n\theight: 100%;\n\twidth: 100%;\n\tpadding: 0.25rem;\n\n\tborder: 0;\n\tbackground: transparent;\n}\n\n.formTitle {\n\tgrid-area: 1 / 1 / 1 / 4;\n\talign-self: center;\n}\n\n#formTitle {\n\twidth: 100%;\n\tpadding: 0.25rem;\n\tfont-size: 1.5rem;\n\tborder-bottom: 1px solid #b5b4b43f;\n}\n\n.formNotes {\n\tgrid-area: 2 / 1 / 4 / 4;\n\talign-self: center;\n\n\theight: 100%;\n\twidth: 100%;\n\tmargin-bottom: 0.25rem;\n\n\tborder-radius: 0.25rem;\n\tborder: 1px solid #a1a2a430;\n}\n\n#formNotes {\n\tpadding: 10px;\n}\n\ntextarea {\n\tresize: none;\n\toverflow: scroll;\n}\n\n.formDate,\n.formList,\n.formPriority {\n\talign-self: end;\n\tpadding: 10px 0px;\n}\n\n.formList {\n\tgrid-area: 4 / 1;\n\tjustify-self: baseline;\n\twidth: 100%;\n}\n\n#formList {\n\tpadding-left: 10px;\n\tfont-size: 1.1rem;\n\tfont-weight: 300;\n}\n\n.formDate {\n\tgrid-area: 4 / 2;\n\n\tdisplay: flex;\n\tjustify-self: center;\n\tjustify-content: center;\n}\n\n#formDate {\n\tdisplay: flex;\n\talign-content: center;\n\n\twidth: 70%;\n\n\ttext-align: center;\n\tfont-size: 1rem;\n\tfont-weight: 300;\n}\n\n.formPriority {\n\tgrid-area: 4 / 3;\n\tpadding-right: 10px;\n\n\tfont-size: 1.1rem;\n\tfont-weight: 300;\n}\n\n#formPriority {\n\ttext-align: right;\n}\n\n#formList,\n#formPriority {\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n\n.submitButton {\n\tz-index: 3;\n\tposition: absolute;\n\tbottom: -3rem;\n\n\theight: 2rem;\n\twidth: 6.5rem;\n\n\talign-self: end;\n\tjustify-self: center;\n\n\tbackground: #e3e3e3;\n\tbackdrop-filter: blur(20px);\n\t-webkit-backdrop-filter: blur(20px);\n\tborder: 1px solid #e4e4eb;\n\tborder-radius: 3.125rem;\n\tbox-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),\n\t\t0px 0px 2px 0px rgba(40, 41, 61, 0.04);\n\n\tfont-family: Inter, sans-serif;\n\tcolor: #1c1c28;\n\tfont-feature-settings: 'clig' off, 'liga' off;\n\tfont-size: 1.1rem;\n\tfont-style: normal;\n\tfont-weight: 300;\n\n\tcursor: pointer;\n}\n\n/* TODO CARD */\n\n.todoCard {\n\tposition: relative;\n\n\tdisplay: grid;\n\tgrid-template-columns: 1rem auto 4rem 1rem;\n\tgrid-template-rows: 1.5rem;\n\tgap: 0.25rem;\n\trow-gap: 0.5rem;\n\toverflow: clip;\n\n\twidth: clamp(20rem, 35rem, 35rem);\n\tmin-height: 2.6875rem;\n\theight: 2.6875rem;\n\n\tmargin: 0.5rem;\n\tpadding: 0.5rem;\n\n\tborder-radius: 0.9375rem;\n\n\tcursor: pointer;\n}\n\n.todoCardExtra {\n\tgrid-template-rows: 1.5rem auto;\n\n\ttransition: min-height 1s;\n}\n\n.todoCardExtra:hover {\n\tmin-height: 10rem;\n}\n\n/* Create custom checkbox */\n.todoCheck {\n\tgrid-area: 1 / 1;\n\talign-self: center;\n}\n\n.todoTitle {\n\tgrid-area: 1 / 2 / 1 / 4;\n\theight: 100%;\n\n\t/* overflow: hidden; */\n\ttext-overflow: ellipsis;\n\n\tfont-family: Inter, sans-serif;\n\tcolor: #1c1c28;\n\tfont-size: 1.1rem;\n\tfont-style: normal;\n\tfont-weight: 300;\n\tline-height: 1;\n\n\tpadding: 0.25rem;\n\tmargin: 0;\n\theight: 100%;\n}\n\n.todoNotes {\n\tgrid-area: 2 / 2 / 2 / 4;\n\tpadding: 4px;\n\tmargin: 0;\n\tborder-radius: 0.25rem;\n\tborder: 1px solid #a1a2a430;\n\n\tfont-family: Inter, sans-serif;\n\tfont-size: 0.75rem;\n\tfont-weight: 300;\n\toverflow: scroll;\n}\n\n.todoDate {\n\tgrid-area: 1 / 3;\n\talign-self: center;\n\n\tcolor: rgba(0, 0, 0, 0.4);\n\tfont-size: 0.625rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.deleteTodo {\n\tgrid-area: 1 / 4;\n\talign-self: center;\n}\n\n/* TODO CARD - edit */\n\n.editCard {\n\tz-index: 3;\n\tposition: relative;\n\n\tdisplay: grid;\n\tgrid-template-rows: 1.5rem auto 1.5rem;\n\tgrid-template-columns: 1rem repeat(3, 1fr) 1rem;\n\tgap: 0.25rem;\n\trow-gap: 0.5rem;\n\n\twidth: clamp(20rem, 35rem, 35rem);\n\tmin-height: 10rem;\n\n\tpadding: 0.5rem;\n\tmargin: 0.5rem 0.5rem 0rem;\n\tborder-radius: 1rem;\n\n\tfont-family: Inter, sans-serif;\n\tcolor: #1c1c28;\n\tfont-style: normal;\n\tfont-weight: 400;\n\ttext-overflow: ellipsis;\n}\n\n.todoTitleEdit,\n.todoDueDateEdit,\n.todoNotesEdit,\n.todoPriorityEdit {\n\tbackground: transparent;\n\tborder: 0;\n\ttext-overflow: ellipsis;\n}\n\n.deleteTodoEdit {\n\tgrid-row: 1;\n\tgrid-column: 5;\n\n\talign-self: center;\n}\n\n.todoCheckEdit {\n\tgrid-area: 1 / 1 / 1 / 1;\n\n\talign-self: center;\n}\n\n.todoTitleEdit {\n\tgrid-area: 1 / 2 / 1 / 5;\n\n\theight: 100%;\n\tpadding: 0.25rem;\n\n\tfont-size: 1.1rem;\n\tfont-weight: 300;\n}\n\n.todoNotesEdit {\n\talign-self: center;\n\n\tgrid-column: 2 / span 3;\n\tgrid-row: 2;\n\n\theight: 100%;\n\tpadding: 0.25rem;\n\tborder-radius: 0.25rem;\n\tborder: 1px solid #a1a2a430;\n\n\tfont-size: 0.75rem;\n\tfont-weight: 300;\n}\n\n.todoListEdit {\n\talign-self: center;\n\tjustify-self: start;\n\n\tgrid-column: 2;\n\tgrid-row: 3;\n\n\twidth: 90%;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\n\tfont-size: 0.9rem;\n\tfont-weight: 300;\n\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n\n.todoDueDateEdit {\n\tjustify-self: center;\n\talign-self: center;\n\n\tgrid-column: 3;\n\tgrid-row: 3;\n\n\twidth: 90%;\n\tpadding: 0;\n\n\ttext-align: center;\n\tfont-size: 0.9rem;\n\tfont-weight: 300;\n}\n\n.todoPriorityEdit {\n\talign-self: center;\n\tjustify-self: end;\n\n\tgrid-column: 4;\n\tgrid-row: 3;\n\n\twidth: 90%;\n\tpadding: 0;\n\n\tfont-size: 0.9rem;\n\ttext-align: end;\n\tfont-weight: 300;\n\n\t-moz-appearance: none;\n\t-webkit-appearance: none;\n}\n\n.done > * {\n\tcolor: #8080807d;\n\ttext-decoration: line-through;\n\tcolor: rgba(128, 128, 128, 0.64);\n}\n\n/* Priority */\n.low {\n\tbackground: linear-gradient(var(--base-white), var(--base-white)) padding-box,\n\t\tvar(--gradient-blue) border-box;\n\tborder: 1px solid;\n\tborder-bottom: 2px solid;\n\tborder-color: transparent;\n\tbox-shadow: 0px 8px 16px 0px rgba(62, 123, 250, 0.35),\n\t\t0px 2px 4px 0px rgba(62, 123, 250, 0.37);\n}\n\n.medium {\n\tbackground: linear-gradient(var(--base-white), var(--base-white)) padding-box,\n\t\tvar(--gradient-orange) border-box;\n\tborder: 0.1rem solid;\n\tborder-bottom: 2px solid;\n\tborder-color: transparent;\n\tbox-shadow: 0px 8px 16px 0px rgba(255, 136, 0, 0.23),\n\t\t0px 2px 4px 0px rgba(255, 136, 0, 0.4);\n}\n\n.high {\n\tbackground: linear-gradient(var(--base-white), var(--base-white)) padding-box,\n\t\tvar(--gradient-red) border-box;\n\tborder: 0.1rem solid;\n\tborder-bottom: 2px solid;\n\tborder-color: transparent;\n\tbox-shadow: 0px 8px 16px 0px rgba(255, 59, 59, 0.35),\n\t\t0px 2px 4px 0px rgba(255, 59, 59, 0.69);\n}\n\n.none {\n\tbackground: var(--base-white, #fff);\n\tborder: 1px solid #e4e4eb;\n\n\tbox-shadow: 0px 8px 16px 0px rgba(96, 97, 112, 0.16),\n\t\t0px 2px 4px 0px rgba(40, 41, 61, 0.04);\n}\n\n/* displayChange */\n.changeAlert {\n\tz-index: 80;\n\n\tposition: fixed;\n\tbottom: -10%;\n\tleft: 50%;\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\ttransform: translateX(-50%) translateY(0%);\n\ttransition: transform 0.6s;\n\n\theight: 3.4375rem;\n\tpadding: 0 1rem;\n\tborder-radius: 0.5rem;\n\tborder: 1px solid var(--stroke-soft, #f2f2f5);\n\tbackground: var(--base-white, #fff);\n\tbox-shadow: 0px 4px 8px 0px rgba(96, 97, 112, 0.16),\n\t\t0px 0px 2px 0px rgba(40, 41, 61, 0.04);\n\n\tcolor: #1c1c28;\n\n\tfont-family: Inter, sans-serif;\n\tfont-size: 1.3rem;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 2rem; /* 133.333% */\n\ttext-transform: uppercase;\n\n\tanimation: showChangeAnimation 2.5s;\n}\n\n@keyframes showChangeAnimation {\n\t0% {\n\t\tbottom: -10rem;\n\t}\n\t25% {\n\t\tbottom: 0rem;\n\t}\n\t75% {\n\t\tbottom: 0rem;\n\t}\n\t100% {\n\t\tbottom: -10rem;\n\t}\n}\n\nfooter {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
